import { IFeedbackItem } from 'types/income';
import { converters as tableConverters } from 'store/table';
import { loaders } from './feedback.loaders';
import { FeedbackItem } from './feedback.types';

const convertFeedbackItem = (feedbackItem: IFeedbackItem): FeedbackItem => {
  return {
    id: feedbackItem.id,
    entity: {
      variant: feedbackItem.entity,
      id: feedbackItem.subjectId,
      label: feedbackItem.entityLabel,
    },
    title: feedbackItem.title ?? '',
    content: feedbackItem.content,
    adminNotes: feedbackItem.adminNotes ?? '',
    status: feedbackItem.status,
    employee: feedbackItem.employeeId
      ? {
          id: feedbackItem.employeeId,
          fullName: feedbackItem.employeeFullName ?? '',
          email: feedbackItem.employeeEmail ?? '',
        }
      : null,
    admin: feedbackItem.adminId
      ? {
          id: feedbackItem.adminId,
          fullName: feedbackItem.adminFullName ?? '',
          email: feedbackItem.adminEmail ?? '',
        }
      : null,
    resolvedByAdmin: feedbackItem.resolvedByAdminId
      ? {
          id: feedbackItem.resolvedByAdminId,
          fullName: feedbackItem.resolvedByAdminFullName ?? '',
        }
      : null,
    createdAt: feedbackItem.createdAt,
    updatedAt: feedbackItem.updatedAt ?? null,
    resolvedAt: feedbackItem.resolvedAt ?? null,
  };
};

const convertFeedbackItems = (
  feedbackItems: IFeedbackItem[],
): FeedbackItem[] => {
  return feedbackItems.map(convertFeedbackItem);
};

export const converters = {
  getFeedbackItems: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getFeedbackItems>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertFeedbackItems(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getFeedbackItem: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getFeedbackItem>>) => {
    return convertFeedbackItem(data);
  },
};
